<template>
    <span class="trigger-button" v-if="show">
        <span
            class="button"
            :class="cssClass"
            v-if="!this.processing"
            @click.prevent="clicked()"
            v-html="buttonLabel"
        ></span>
        <span
            class="disabled button"
            :class="cssClass"
            v-if="this.processing"
            v-html="processingButtonLabel"
        ></span>
    </span>
</template>
<script>
    import EventMixin from '../../mixins/EventMixin';
    export default {
        props: {
            labelOn: {
                type: String,
                required: true
            },
            labelOff: {
                type: String,
                required: true
            },
            group: {
                type: String,
                required: false
            },
            icon: {
                type: String,
                required: false
            },
            cssClass: {
                type: String,
                required: false,
                default() {
                    return '';
                }
            },
            show: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data() {
            return {
                processing: false,
                eventMixin: new EventMixin(this.group)
            };
        },
        computed: {
            buttonLabel() {
                if (!this.icon) {
                    return this.labelOn;
                }
                return '<span class="' + this.icon + '"></span>' + ' ' + this.labelOn;
            },
            processingButtonLabel() {
                return '<i class="fas fa-spinner fa-spin fa-fw"></i> ' + this.labelOff;
            }
        },
        mounted() {
            window.EventHandler.listen(
                this.eventMixin.target('start'),
                this.startButton
            );
            window.EventHandler.listen(
                this.eventMixin.target('stop'),
                this.stopButton
            );
        },
        methods: {
            startButton() {
                this.processing = true;
            },
            stopButton() {
                this.processing = false;
            },
            clicked() {
                window.EventHandler.fire(this.eventMixin.target('trigger'));
            }
        }
    };
</script>